/**
 * How a pay-in-store booking can be settled at the appointment.
 *
 * Gift Card is listed only while the salon has gift cards switched on (and is
 * on Full, the only plan they work on). A salon that switched them off can
 * still take cards it sold earlier at the desk, but it is not offering gift
 * cards any more, so they are not advertised.
 */
export const inStorePaymentMethods = (
  company?: {
    status?: string | null;
    gift_cards_enabled?: boolean | null;
  } | null
) =>
  company?.status === "FULL" && company.gift_cards_enabled
    ? "Cash, Credit Card, Gift Card, or Apple Pay"
    : "Cash, Credit Card, or Apple Pay";

export function canBuyGiftCard(
  company?: {
    status?: string | null;
    gift_cards_enabled?: boolean | null;
    gift_cards_online_enabled?: boolean | null;
    stripe_user_id?: string | null;
  } | null
): boolean {
  return Boolean(
    company?.status === "FULL" &&
      company.gift_cards_enabled &&
      company.gift_cards_online_enabled &&
      company.stripe_user_id
  );
}
